import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import {Accordion, Card, Button, ListGroup, Badge} from 'react-bootstrap';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {
  CABINET_SLUG,
  getDepartmentForMenu
} from '../../config';


const MenuNavLink = ({ root, title, param, counter, counter_value, single=false }) => {
 return (
      <NavLink to={ root + ( param !== '#' ? param + '/' : '' ) }
               // exact
               activeClassName="font-weight-bold"
               className={ single ? 'btn btn-link cabinet-menu-item__head' : '' }>
          { title }{' '}
          { counter_value > 0 && <MenuBadge counter={counter} value={counter_value} />}
      </NavLink>
 )
}

MenuNavLink.propTypes = {
  root: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  param: PropTypes.string.isRequired,
  counter: PropTypes.shape({
    variant: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
  counter_value: PropTypes.number.isRequired,
  single: PropTypes.bool.isRequired,
}

const MenuBadge = ({ counter, value }) => {
 return (
  <Badge variant={ counter.variant } title={ counter.title }>{ value }</Badge>
 )
}

MenuBadge.propTypes = {
  counter: PropTypes.shape({
    variant: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
  value: PropTypes.number.isRequired,
}

const Menu = (props) => {
  let location = useLocation();
  const defaultActiveAccordionKey = location.pathname.split('/').filter(i => i.length > 0).slice(2)[0];

  const [menu, setMenu] = useState(null);

  const getAccordionSubMenu = (root, menuItem) => {
    function getMenuChildren(){
      const tree = menuItem.children;
      let list = [];

      for (const [key, value] of Object.entries(tree)) {
        let item = {...value, key};
        if (value.is_moderator) {
          if (props.is_moderator) list.push(item);
          continue;
        }
        if (value.is_staff) {
          if (props.is_staff) list.push(item);
          continue;
        }
        if (value.is_teacher) {
          if (props.is_teacher) list.push(item);
          continue;
        }
        if (value.yandex_saved_payment) {
          if (props.yandex_saved_payment) list.push(item);
          continue;
        }
        if (value.paypal_subscription) {
          if (props.paypal_subscription) list.push(item);
          continue;
        }
        list.push(item);
      }
      return list.map(i => <ListGroup.Item key={i.key}>{ getSimpleSubMenu(root, i) }</ListGroup.Item>)
    }

    return(<>
      <Accordion defaultActiveKey={ defaultActiveAccordionKey }>
        <Accordion.Toggle as={ Button } variant="link" eventKey={ menuItem.key }>
          { menuItem.title }{' '}
          { (menuItem.counter && props[menuItem.counter.key] > 0) && <MenuBadge counter={ menuItem.counter }
                                                                                value={ props[menuItem.counter.key] } />}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={ menuItem.key }>
          <ListGroup className='cabinet-menu-item-list'>
            { getMenuChildren() }
          </ListGroup>
        </Accordion.Collapse>
      </Accordion>
      { menuItem.is_moderator && <hr/> }
    </>)
  }

  const getSimpleSubMenu = (root, menuItem, single=false) => {
    if (menuItem.old_version){
      let href = root + menuItem.key + '/';
      if (menuItem['item_key'] === 'accounts/transfers' || menuItem['item_key'] === 'stat/actions'){
        href='/' + props.lang + '/' + CABINET_SLUG + '/' + menuItem.key + '/';
      }
      return <a href={ href } className={ single ? 'btn btn-link cabinet-menu-item__head' : '' }>
              { menuItem.title }
            </a>
    }
    return <MenuNavLink key={ menuItem.key }
                        root={ root }
                        param={ menuItem.key }
                        title={ menuItem.title }
                        counter={ menuItem.counter }
                        counter_value={ menuItem.counter ? props[menuItem.counter.key] : 0 }
                        single={ single }/>
  }


  useEffect(() => {
    const tree = getDepartmentForMenu(props.is_moderator, props.is_staff);
    const menuItems = [];
    for (const value of Object.values(tree)) {
      let root = '/'+lang+'/' + CABINET_SLUG + '/';
      if (value.children){
        root = '/'+lang+'/' + CABINET_SLUG + '/' + value['key'] + '/';
        menuItems.push(getAccordionSubMenu(root, value));
      } else {
        menuItems.push(getSimpleSubMenu(root, value, true));
      }
    }
    setMenu(menuItems);
  }, []);


  if (props.isAuth){
    return <Card className={'cabinet-menu'}>
      <Card.Body>
        <nav>
          { menu }
          <a href='/logout' className='btn btn-link cabinet-menu-item__head'>{gettext('Выход')}</a>
        </nav>
      </Card.Body>
    </Card>;
  } else {
    return <Card className={'cabinet-menu'}>
      <Card.Body>
        <nav>
          <NavLink to={'/'+lang+'/' + CABINET_SLUG + '/cart/'} activeClassName="font-weight-bold" className='btn btn-link cabinet-menu-item__head'>
              {gettext('Моя Корзина')} {props.cartCounter > 0 && <Badge variant="primary">{props.cartCounter}</Badge>}
          </NavLink>
        </nav>
      </Card.Body>
    </Card>;
  }

};

const mapStateToProps = (state) => {
  return {
    isAuth: state.auth.isAuth,
    lang: state.auth.lang,

    moderatorCounter: state.auth.moder_count,
    moderatorArrangementCounter: state.shop.arrangements_moder_count,
    moderatorLessonsCounter: state.shop.lessons_moder_count,

    arrangementCounter: state.shop.arrangements_count,
    lessonsCounter: state.shop.lessons_count,
    couponsCounter: state.auth.coupons_count,
    favoritesCounter: state.auth.favorites_count,
    cartCounter: state.auth.cart_count,
    notificationsCounter: state.auth.notifications_count,
    messagesCounter: state.auth.messages_count,
    commentsCounter: state.auth.comments_count,
    aphorismsCounter: state.auth.aphorisms_count,
    collectionsCounter: state.auth.collection_arrangements_count,
    playlistsCounter: state.auth.collection_playlists_count,
    authorsCounter: state.auth.collection_authors_count,
    genresCounter: state.auth.collection_genres_count,
    // userId: state.auth.id,

    is_moderator: state.auth.is_moderator,
    is_staff: state.auth.is_staff,
    is_seller: state.auth.is_seller,
    is_teacher: state.auth.is_teacher,
    is_disciple: state.auth.is_disciple,
    yandex_saved_payment: state.auth.yandex_saved_payment,
    paypal_subscription: state.auth.paypal_subscription,
  }
};

export default compose(
  connect(mapStateToProps, {}),
)(Menu);